(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("homePage", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/customPages/homePageView.html",
            bindToController: true,
            controller: ["authService", "publicResource", "messageService", "frameworkService", "homePageService", "$rootScope", "$scope", "$timeout", "ngMeta", HomePageCtrl],
            controllerAs: "vm"
        };
        function HomePageCtrl(authService, publicResource, messageService, frameworkService, homePageService, $rootScope, $scope, $timeout, ngMeta) {
            var vm = this;
            vm.dataLoaded = false;
            vm.framework = frameworkService.data;
            loadPage();
            //////////////////////////////////
            function loadPage() {
                if (frameworkService.data.tenant) {
                    if (frameworkService.data.tenant.hasHomePage) {
                        publicResource.homePage(function (data) {
                            ngMeta.setTitle(data.title);
                            if (data.description)
                                ngMeta.setTag("description", data.description);
                            vm.content = data.content;
                            vm.dataLoaded = true;
                            $rootScope.$broadcast("prerenderReady");
                        }, function (error) {
                            messageService.error(error);
                        });
                    }
                    else {
                        if (authService.authentication.isAuth) {
                            homePageService.loadSignedInHomePage();
                        }
                        else {
                            vm.showSignin = true;
                        }
                        $rootScope.$broadcast("prerenderReady");
                    }
                }
            }
            ////Reload the home page when site language is changed
            var navBarLanguageChangedCancel = $scope.$on("navBarLanguageChanged", function () {
                $timeout(function () {
                    loadPage();
                });
            });
            this.$onDestroy = function () {
                if (navBarLanguageChangedCancel)
                    navBarLanguageChangedCancel();
            };
        }
    });
}());
